export default __webpack_public_path__ + "static/media/dozule8.fc98cac3.jpg";